import { REMOVEMEMBER_SUCCESS, REMOVEMEMBER_FAIL } from '../actionTypes';

const initialState = {
    user: null,
    loading: false
};

const removeMemberReducer = (state = initialState, action) => {
    switch (action.type) {
        case REMOVEMEMBER_SUCCESS:
            return {
                ...state,
                loading: true,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case REMOVEMEMBER_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default removeMemberReducer;
